<script setup lang="ts">
import YouTubeInline from "~/components/ui/YoutubeInline.vue";
import TypEnvelope from "~/components/icons/typ/typ-envelope.vue";
import TypContract from "~/components/icons/typ/typ-contract.vue";
import TypSmile from "~/components/icons/typ/typ-smile.vue";
import TypFb from "~/components/icons/typ/typ-fb.vue";
import TypIg from "~/components/icons/typ/typ-ig.vue";

const local = await getLocale("typ", "typ");
const emit = defineEmits(["init"]);

defineComponent({
  name: "Typ",
});

defineProps({
  name: {
    type: String,
    required: true,
  },
  videoId: {
    type: String,
    required: true,
  },
});
onMounted(() => emit("init"));
</script>

<template>
  <div
    class="w-11/12 sm:max-w-7xl mx-auto shadow-lg rounded-3xl bg-white mt-4 mb-10 lg:my-10"
  >
    <div class="mx-auto text-sm sm:text-base leading-tight text-gray-700">
      <h3
        class="pageTitle pt-8 !text-center"
        v-html="local.header.replace('%d', name)"
      ></h3>
      <h4 class="text-center text-lg sm:text-xl mb-4 sm:mb-8 font-semibold px-6" v-html="local.subheader" />
      <h1 class="text-lg sm:text-xl text-center  mt-4 sm:mb-4 bg-yellow py-2 font-semibold">
        <div v-html="local.title"></div>
      </h1>
      <div class="max-w-4xl text-lg mx-auto py-4 px-6">
        <div class="flex mb-6 items-center">
          <div class="w-1/5 text-center">
            <TypEnvelope class="h-12 mx-auto" />
          </div>
          <div class="w-4/5 pl-4 sm:pl-0 text-sm">
            <div class="font-semibold text-lg">{{ local.instructions.first_title }}</div>
            <span v-html="local.instructions.first"></span>
          </div>
        </div>
        <div class="flex mb-6 items-center">
          <div class="w-1/5 text-center">
            <TypContract class="h-12 mx-auto" />
          </div>
          <div class="w-4/5 pl-4 sm:pl-0 text-sm">
            <div class="font-semibold text-lg">{{ local.instructions.second_title }}</div>
            <div v-html="local.instructions.second" />
          </div>
        </div>
        <div class="flex mb-6 items-center">
          <div class="w-1/5 text-center">
            <TypSmile class="h-12 mx-auto" />
          </div>
          <div class="w-4/5 pl-4 sm:pl-0 text-sm">
            <div class="font-semibold text-lg">{{ local.instructions.third_title }}</div>
            <span v-html="local.instructions.third"></span>
          </div>
        </div>

        <h2
          class="text-xl sm:text-3xl font-semibold text-center mt-6 mb-4"
        >
          <div v-html="local.signature.title"></div>
        </h2>
        <div
          class="w-full sm:w-4/5 flex items-center justify-center mx-auto relative"
        >
          <YouTubeInline ref="video" :video-id="videoId" />
        </div>

        <div class="text-center mt-8">
          <div v-html="local.thanks"></div>
        </div>
      </div>
    </div>
    <div class="spacer h-6" />
  </div>

</template>

<style scoped>
  .typList li::before {
    content: '▪';
    margin-right: 0.75rem;
    color: rgb(55, 65, 81);
  }
</style>
